export default __webpack_public_path__ + "static/media/15.696f12f8.jpg";